import styled, { css } from "styled-components";

export const HomeYoutubeWrapper = styled.div`
  width: 100%;
`;

export const HomeYoutubeHeader = styled.div`
  width: 100%;
  text-align: left;

  font-weight: 700;
  font-size: 18px;
  line-height: 100%;

  > span {
    color: #4c41d3;
  }
`;

export const HomeYoutubeVideoWrapper = styled.div`
  margin-top: 20px;
  padding: 0 16px;
`;

export const HomeYoutubeVideoRow = styled.div`
  width: 100%;
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto auto;
  gap: 12px 8px;
`;

export const HomeYoutubeVideoItem = styled.div<{ index: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  ${({ index }) =>
    index === 0 &&
    css`
      grid-column: span 2;
    `}
  ${({ index }) =>
    index === 1 &&
    css`
      grid-row: 2;
      min-width: 0;
    `}
      ${({ index }) =>
    index === 2 &&
    css`
      grid-row: 2;
      min-width: 0;
    `}
`;

export const HomeYoutubeVideoItemThumbnail = styled.div`
  position: relative;
  width: 100%;
  height: auto;
`;

export const HomeYoutubeVideoItemThumbnailImage = styled.img`
  border-radius: 9.14px;
  width: 100%;
  height: auto;
  object-fit: cover;
  aspect-ratio: 328/165;
`;
export const HomeYoutubeVideoItemBurl = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 9.14px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 50%,
    rgba(0, 0, 0, 0.9) 100%
  );
`;

export const HomeYoutubeVideoItemPlayButton = styled.div<{ index: number }>`
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #67676780;
  backdrop-filter: blur(18.274112701416016px);
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    width: 10px;
    height: 10px;
  }

  ${({ index }) =>
    index === 0 &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 44px;
      height: 44px;

      > img {
        width: 20px;
        height: 20px;
      }
    `}
  ${({ index }) =>
    index === 1 &&
    css`
      bottom: 9px;
      left: 9px;
    `}
      ${({ index }) =>
    index === 2 &&
    css`
      bottom: 9px;
      left: 9px;
    `}
`;

export const HomeYoutubeVideoItemContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  > .title {
    font-weight: 500;
    font-size: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
export const HomeYoutubeVideoItemContentChannel = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  > img {
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }

  > .name {
    font-weight: 500;
    font-size: 13px;
    color: #767678;
  }
`;

export const HomeYoutubeChannelWrapper = styled.div`
  margin-top: 20px;
  padding-left: 16px;
`;

export const HomeYoutubeChannelListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  .channel-list {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* Four items per row */
    gap: 16px;
    width: 100%;
  }
`;

export const HomeYoutubeChannelItem = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  background: white;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const HomeYoutubeChannelTitleRow = styled.div`
  padding: 0 16px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .title {
    color: var(--Black-400, #444);

    font-size: 18px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.4px;
  }
`;

export const HomeYoutubeChannelItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const HomeYoutubeChannelItemThumbnailImage = styled.div<{
  width: number;
}>`
  width: 100%;
  max-width: ${(p) => p.width}px;
  height: ${(p) => p.width}px;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const HomeYoutubeChannelItemInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const HomeYoutubeChannelItemTitleRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  > .title {
    white-space: nowrap; //5글자 이상이면 2줄
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--Black-400, #444);

    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.28px;
  }
`;

// 스켈레톤 로딩 스타일
const shimmer = css`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonBox = styled.div<{
  width?: string;
  height?: string;
  marginTop?: string;
  marginBottom?: string;
}>`
  ${shimmer}
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "20px"};
  border-radius: 8px;
  margin-top: ${({ marginTop }) => marginTop || "0"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "0"};
`;

export const SkeletonThumbnail = styled.div`
  ${shimmer}
  width: 100%;
  height: 100%;
  aspect-ratio: 328/165;
  border-radius: 12px;
  position: absolute;
  top: 0;
  left: 0;
`;

export const SkeletonText = styled.div<{
  width?: string;
  height?: string;
  marginTop?: string;
}>`
  ${shimmer}
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "14px"};
  border-radius: 4px;
  margin-top: ${({ marginTop }) => marginTop || "0"};
`;

export const SkeletonChannelAvatar = styled.div`
  ${shimmer}
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
`;
